export default __webpack_public_path__ + "static/media/duckie.3ad65065.png";